import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ContentHeader, Loader} from '@components';
import {Link, useNavigate} from 'react-router-dom';
import {Modal, Button, Form} from 'react-bootstrap';
import {logoutUser} from '@app/store/reducers/auth';
import {toast} from 'react-toastify';
import {fetch} from '../../apiFunction';
import {BASE_URL} from '../../config';
import {getAllUsers} from '../../services/user';
import handleStatus from '../../utils/ajax';
import Pagination from '../../components/pagination/index';
import 'react-toastify/dist/ReactToastify.css';

interface UserAssignedLeavesModalProps {
  show: boolean;
  handleClose: () => void;
  assignedAnnualLeaves: number;
  updateUserWithAnnualLeaves: (annualAssignedLeaves: number) => void;
}

const AssignedAnnualLeaves: React.FC<UserAssignedLeavesModalProps> = ({
  show,
  handleClose,
  assignedAnnualLeaves,
  updateUserWithAnnualLeaves
}) => {
  const [assignAnnualLeave, setAssignAnnualLeave] = useState<number>(
    assignedAnnualLeaves || 0
  );
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleSubmit = async () => {
    console.log(assignAnnualLeave, 'assignAnnualLeave***************');
    updateUserWithAnnualLeaves(assignAnnualLeave);
    handleClose();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = Number(e.target.value);

    // Ensure value is within range
    if (value < 0) {
      setErrorMessage('Annual leaves cannot be less than 0.');
      value = 0;
    } else if (value > 12) {
      setErrorMessage('Annual leaves cannot be more than 12.');
      value = 12;
    } else {
      setErrorMessage(''); // Clear error if within valid range
    }

    setAssignAnnualLeave(value);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <>
        <Modal.Header>
          <Modal.Title>Assigned Annual Leaves</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="assignedLeaves">
              <Form.Label>Enter Annual Leaves</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter annual leaves"
                value={assignAnnualLeave || 0}
                onChange={handleChange}
                min={0}
                max={12}
              />
            </Form.Group>
          </Form>
          {errorMessage && (
            <span style={{color: 'red', fontSize: '14px'}}>{errorMessage}</span>
          )}
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </>
    </Modal>
  );
};

const AllUsers = () => {
  const [userData, setUserData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [postPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [assignedLeave, setAssignedLeave] = useState(0);
  const [search, setSearch] = useState('');
  const [userId, setUserId] = useState('');

  const [pageNo, setPageNo] = useState(
    Number(localStorage.getItem('PageNo')) || 1
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const path = localStorage.getItem('Path');
  // const pageNo = Number(localStorage.getItem('PageNo')) || 1;
  const loginUser = useSelector((state: any) => state.auth.currentUser);
  useEffect(() => {
    if (path === 'users' && pageNo !== 1) {
      setCurrentPage(+pageNo);
      getAllUsersRecord({pageNo});
    } else {
      localStorage.setItem('Path', 'users');
      localStorage.setItem('PageNo', currentPage.toString());
      getAllUsersRecord({pageNo});
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('PageNo', currentPage.toString());
  }, [currentPage]);

  const getAllUsersRecord = async (query: any) => {
    setShowLoader(true);
    const response = await getAllUsers(query);
    handleStatus(response?.status, () => dispatch(logoutUser()), navigate);
    if (response?.data?.ok) {
      setShowLoader(false);
      const responseUserData = response?.data?.data;
      setUserData(responseUserData);
      setTotalRecords(response.data.totalRecords);
      setShowLoader(false);
    }
  };

  const handleInputChange = (e: any) => {
    const value = e?.target?.value;
    if (value.trim() !== '') {
      setSearch(value);
    } else {
      setSearch('');
    }
  };

  const filterData = async () => {
    await getAllUsersRecord({
      search
    });
  };

  const resetData = async () => {
    await getAllUsersRecord({});
    setSearch('');
  };

  const paginate = (pageno: React.SetStateAction<number>) => {
    getAllUsersRecord({pageNo: pageno});
    setCurrentPage(pageno);
    setSearch('');
  };

  const handleOpenModal = (totalAssigendLeave: number, userId: string) => {
    console.log('open model*****************', totalAssigendLeave, userId);
    setShowModal(true);
    setAssignedLeave(totalAssigendLeave);
    setUserId(userId);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const updateUserWithAnnualLeaves = async (assignAnnualLeaves: number) => {
    const url = `${BASE_URL}/user/update`;
    const type = 'post';
    const payload = {
      annualLeaves: assignAnnualLeaves,
      userId
    };
    // console.log(payload, 'payload while updating users********************8');
    try {
      const resp = await fetch(url, type, payload, token);
      if (resp && !resp?.data?.ok) {
        toast.error(resp?.data?.message || 'Error while updating user');
        return;
      }
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      if (resp.status === 200) {
        toast.success('User Updated sucessfully');
        navigate('/all-users');
        setSearch('');
        await getAllUsersRecord({pageNo});
      }
    } catch (error) {
      toast.error('An unexpected error occurred while updating user');
    }
  };

  if (showLoader) {
    return <Loader title="Daily" />;
  }

  console.log(userData, 'userData********************');
  return (
    <>
      <ContentHeader title="All Users" />
      {showModal && (
        <AssignedAnnualLeaves
          show={showModal}
          handleClose={handleClose}
          assignedAnnualLeaves={assignedLeave}
          updateUserWithAnnualLeaves={updateUserWithAnnualLeaves}
        />
      )}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">All Users Listing</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-start flex-wrap">
                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Search by userName or email"
                        value={search}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-group-append">
                      <button
                        type="submit"
                        className="btn btn-lg btn-default"
                        onClick={filterData}
                      >
                        <i className="fa fa-search" />
                      </button>
                    </div>

                    <div className="input-group-append">
                      <button
                        type="button" // Prevent form submission
                        className="btn btn-lg btn-default"
                        onClick={resetData}
                        style={{marginLeft: '10px'}}
                      >
                        <i className="fa fa-undo" /> {/* Icon for reset */}
                      </button>
                    </div>
                  </div>
                  <div className="card-body table-responsive p-0">
                    <table className="table table-striped projects">
                      <thead>
                        <tr>
                          <th className="text-left">User Name</th>
                          <th className="text-center">Email</th>
                          <th className="text-center">Profile</th>
                          {loginUser?.data?.permissions[0] !== 'hr' ? (
                            <th className="text-center">Active Project</th>
                          ) : (
                            ''
                          )}
                          <th className="text-right"> Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.map(
                          ({
                            user: {_id: id, name, email, profile, annualLeaves},
                            imageLink,
                            projectName
                          }: any) => {
                            if (!profile) {
                              imageLink = '/img/default-profile.png';
                            }
                            return (
                              <tr key={id}>
                                <td>
                                  <span>{name}</span>
                                </td>
                                <td style={{textAlign: 'center'}}>{email}</td>
                                <td style={{textAlign: 'center'}}>
                                  <ul className="list-inline offset-4 m-0">
                                    <li className="list-inline-item">
                                      <img
                                        alt="Avatar"
                                        className="table-avatar"
                                        src={imageLink}
                                      />
                                    </li>
                                  </ul>
                                </td>
                                {loginUser?.data?.permissions[0] !== 'hr' ? (
                                  <td
                                    style={{textAlign: 'center'}}
                                    className="project_progress"
                                  >
                                    <ul className="d-flex flex-wrap m-0">
                                      {projectName.map(
                                        ({_id: id, projectName}: any) => {
                                          return (
                                            <Link to={`/view-project/${id}`}>
                                              {projectName}
                                            </Link>
                                          );
                                        }
                                      )}
                                    </ul>
                                  </td>
                                ) : (
                                  ''
                                )}
                                <td
                                // style={{float: 'right'}}
                                // className="d-flex project-actions"
                                >
                                  <div className="d-flex justify-content-end project-actions">
                                    {/* Assigned Leaves Button */}
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      title="Assigned Leaves"
                                      onClick={() =>
                                        handleOpenModal(annualLeaves || 0, id)
                                      }
                                    >
                                      <i className="fas fa-calendar-day" />
                                    </button>
                                    <Link
                                      className="btn btn-primary btn-sm"
                                      to={`/view-user/${id}`}
                                    >
                                      <i className="fas fa-eye" />
                                    </Link>
                                    <Link
                                      className="btn btn-info btn-sm"
                                      to={`/update/${id}`}
                                    >
                                      <i className="fas fa-pencil-alt" />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-pagination">
              <Pagination
                postsPerPage={postPerPage}
                totalPosts={totalRecords}
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
          </div>
        </div>

        <div className="modal fade" id="modal-default">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Default Modal</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>One fine body&hellip;</p>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllUsers;
